module.exports = __webpack_public_path__ + "img/ic_cow_selected.5c371978.png";